import { useSegmentFilterCascaded } from "@repo/baseCloud";
import { FilterDropdown, FiltersV2 } from "@repo/ui";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";

import type { BackgroundChecksFilter } from "./types";

import BackgroundChecksApi from "../../api/backgroundChecksApi";
import { emptySegmentFilters, MarketersDropdown } from "../../components/segmentFilters";
import { BackgroundChecksGrid } from "./grid";

const initialFilters: BackgroundChecksFilter = {
	currentPage: 1,
	itemsPerPage: 25,
	startDate: null,
	endDate: null,
	brandIds: emptySegmentFilters.brandIds,
	channelIds: emptySegmentFilters.channelIds,
	marketerIds: emptySegmentFilters.marketerIds,
	stateIds: emptySegmentFilters.stateIds,
	branchIds: emptySegmentFilters.branchIds,
	status: undefined,
	screeningProviderId: undefined,
};

export function BackgroundChecksPage() {
	const [filters, setFilters] = useState<BackgroundChecksFilter>(initialFilters);
	const [executedFilters, setExecutedFilters] = useState<BackgroundChecksFilter>(initialFilters);
	const availableSegments = useSegmentFilterCascaded(emptySegmentFilters);

	const providersQuery = useQuery({
		queryKey: ["screeningProviders"],
		queryFn: () => BackgroundChecksApi.getScreeningProviders(),
	});

	const filterChanged = useCallback(
		(value: any, name: string) => {
			setFilters((prev) => ({ ...prev, [name]: value }));
		},
		[setFilters],
	);

	return (
		<div className="w-full">
			<FiltersV2
				onApply={() =>
					setExecutedFilters((currentFilters) => ({
						...filters,
						currentPage: 1,
						itemsPerPage: currentFilters.itemsPerPage,
					}))
				}
			>
				<FilterDropdown
					id="screeningProviderId"
					objectName="Providers"
					textProp="Name"
					valueProp="ScreeningProviderId"
					values={providersQuery.data ?? []}
					value={filters.screeningProviderId}
					changeHandler={(v) => filterChanged(v, "screeningProviderId")}
					fullLength
					allOption
				/>
				<MarketersDropdown
					options={availableSegments.marketers}
					loaded={availableSegments.marketersLoaded}
					value={filters.marketerIds ?? []}
					changeHandler={(v) => filterChanged(v, "marketerIds")}
				/>
			</FiltersV2>
			<BackgroundChecksGrid filters={executedFilters} setFilters={setExecutedFilters} bulkImportEnabled={true} />
		</div>
	);
}
